import { createSlice } from "@reduxjs/toolkit";
import constants from "@tracking/utils/constants";
import moment from "moment";
import * as Actions from "../actions";
import {
  listByFilterReducer,
  detalheOcorrensReducer,
  ediReducer,
} from "../reducers";
import { InitialState } from "./models";

const { DATETIME_FORMAT, DAYS_BEFORE } = constants;

const initialState: InitialState = {
  dataEdi: {
    arquivos: {
      total: {},
      entrega: {},
      reversa: {},
      comprovantes: {},
      MP: {}
    },
    ocorrencias: {
      total: {},
      entrega: {},
      reversa: {},
      comprovantes: {},
      MP: {}
    },
    apelidosTransportadoras: [],
    dataEdiByApelido: {
      apelido: "",
    },
    detalheOcorrens: [],
    detalheOcorrensFilters: {
      dataHoraInicial: moment()
        .subtract(DAYS_BEFORE, "days")
        .format(DATETIME_FORMAT.API),
      dataHoraFinal: moment().format(DATETIME_FORMAT.API),
      tipoDocumento: "Todos",
      tipoFiltro: "",
      tipoCarga: "",
      totalItems: 0,
      totalPages: 0,
      valorFiltro: "",
      pagina: 1,
      itensPorPagina: 15,
    },
    detalheOcorrensFiltersCSV: {
      dataHoraInicial: moment()
        .subtract(DAYS_BEFORE, "days")
        .format(DATETIME_FORMAT.API),
      dataHoraFinal: moment().format(DATETIME_FORMAT.API),
      tipoDocumento: "Todos",
      tipoFiltro: "",
      tipoCarga: "",
      totalItems: 0,
      totalPages: 0,
      valorFiltro: "",
      pagina: 1,
      itensPorPagina: 15,
    },
    configTabs: {
      tabInView: 1,
      tabs: [
        // {
        //   title: "Arquivos EDI",
        //   index: 0,
        //   active: true,
        //   name: "arquivos",
        // },
        {
          title: "Ocorrências",
          index: 1,
          active: true,
          name: "ocorrencias",
        },
        {
          title: "Detalhes das ocorrências",
          index: 2,
          active: true,
          name: "detalhesOcorrencias",
        },
      ],
    },
  },
  ediGeralFilters: {
    dataHoraInicial: moment()
      .subtract(DAYS_BEFORE, "days")
      .format(DATETIME_FORMAT.API),
    dataHoraFinal: moment().format(DATETIME_FORMAT.API),
    tipoDocumento: "Entrega",
    extraNameDoc: "Entrega",
    idApelido: "",
    tabAtual: "ocorrencias",
  },
  dataEdiList: {
    open: false,
    filtersCSV: {
      tipoDocumento: "",
    },
    data: [],
  },
};

const ediSlice = createSlice({
  name: "ediApp/edi",
  initialState,
  reducers: {
    updateFiltersEDIList: (state, action) => {
      state.ediGeralFilters = {
        ...state.ediGeralFilters,
        ...action.payload,
      };
    },
    updateFiltersDetalheOcorren: (state, action) => {
      state.dataEdi.detalheOcorrensFilters = {
        ...state.dataEdi.detalheOcorrensFilters,
        ...action.payload,
      };
    },
    changeTab: (state, action) => {
      state.dataEdi.configTabs.tabInView = action.payload;
    },
    setStateDataEdiListOpen: (state, action) => {
      state.dataEdiList.open = action.payload;
      state.dataEdi.dataEdiByApelido = { apelido: "" };
      if (!state.dataEdiList.open) {
        state.ediGeralFilters = {
          dataHoraInicial: moment()
            .subtract(DAYS_BEFORE, "days")
            .format(DATETIME_FORMAT.API),
          dataHoraFinal: moment().format(DATETIME_FORMAT.API),
          tipoDocumento: "Entrega",
          extraNameDoc: "Entrega",
          idApelido: "",
          tabAtual: state.ediGeralFilters.tabAtual,
        };
      }
    },
  },
  extraReducers: (builder) => {
    // Tratamento de dados para a tela de edi arquivos
    builder.addCase(Actions.getArquivos.fulfilled, ediReducer);
    // Tratamento de dados para a tela de edi ocorrens
    builder.addCase(Actions.getOcorrens.fulfilled, ediReducer);
    // Tratamento de dados para a tela de edi por apelido
    builder.addCase(Actions.getDataEdiByApelido.fulfilled, ediReducer);
    // Tratamento de dados para a lista (Campo minado)
    builder.addCase(Actions.getDataListByFilter.fulfilled, listByFilterReducer);
    // Tratamento de dados para os detalhes de ocorrências
    builder.addCase(
      Actions.getDetalheOcorrens.rejected,
      detalheOcorrensReducer
    );
    builder.addCase(
      Actions.getDetalheOcorrens.fulfilled,
      detalheOcorrensReducer
    );
  },
});

export const {
  updateFiltersEDIList,
  updateFiltersDetalheOcorren,
  setStateDataEdiListOpen,
  changeTab,
} = ediSlice.actions;

export default ediSlice.reducer;
